/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DeveloperAppResponse,
} from '../models';
import {
    DeveloperAppResponseFromJSON,
    DeveloperAppResponseToJSON,
} from '../models';

export interface GetDeveloperAppRequest {
    address: string;
}

/**
 * 
 */
export class DeveloperAppsApi extends runtime.BaseAPI {

    /**
     * @hidden
     * Gets developer app matching given address (API key)
     */
    async getDeveloperAppRaw(params: GetDeveloperAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeveloperAppResponse>> {
        if (params.address === null || params.address === undefined) {
            throw new runtime.RequiredError('address','Required parameter params.address was null or undefined when calling getDeveloperApp.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/developer_apps/{address}`.replace(`{${"address"}}`, encodeURIComponent(String(params.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeveloperAppResponseFromJSON(jsonValue));
    }

    /**
     * Gets developer app matching given address (API key)
     */
    async getDeveloperApp(params: GetDeveloperAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeveloperAppResponse> {
        const response = await this.getDeveloperAppRaw(params, initOverrides);
        return await response.value();
    }

}
